import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import AttendanceAddNewRecord from './AttendanceAddNewRecord';
import AttendanceAddAbsences from './AttendanceAddAbsences';

const PL_DAY_ABBR = ['nd', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'];

function AttendanceMobileHeader({
    selectedDateObj,
    dateString,
    onPrevDay,
    onNextDay,
    onDateChange,
    currentTime,
    AmountOfCurrentCheckIn,
    AmountOfWholeCheckIn,
    onRefreshAttendance,
    onRefreshAbsences,
    idConfig,
}) {
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openAbsencesModal, setOpenAbsencesModal] = useState(false);
    const [openPicker, setOpenPicker] = useState(false);
    const [pickerDate, setPickerDate] = useState(dayjs(dateString));
    const anchorRef = useRef(null);

    useEffect(() => {
        setPickerDate(dayjs(dateString));
    }, [dateString]);

    const handleRefresh = () => {
        onRefreshAttendance && onRefreshAttendance();
        onRefreshAbsences && onRefreshAbsences();
    };

    const dayAbbrev = PL_DAY_ABBR[selectedDateObj.getDay()];
    const ddmm = `${String(selectedDateObj.getDate()).padStart(2, '0')}.${String(selectedDateObj.getMonth() + 1).padStart(2, '0')}`;

    return (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton size="small" onClick={onPrevDay}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mx: 0.5 }}>
                        {dayAbbrev} {ddmm}
                    </Typography>
                    <IconButton size="small" onClick={onNextDay}>
                        <ChevronRightIcon />
                    </IconButton>
                    <Box ref={anchorRef} sx={{ display: 'inline-flex' }}>
                        <IconButton size="small" onClick={() => setOpenPicker(true)}>
                            <CalendarMonthIcon fontSize="small" />
                        </IconButton>
                        <DatePicker
                            open={openPicker}
                            onClose={() => setOpenPicker(false)}
                            value={pickerDate}
                            onChange={(newValue) => {
                                setPickerDate(newValue);
                                onDateChange(newValue);
                            }}
                            slotProps={{
                                field: { sx: { display: 'none' } },
                                popper: { anchorEl: () => anchorRef.current },
                            }}
                        />
                    </Box>
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {currentTime}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
                <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 0.75,
                    border: '1px solid', borderColor: 'divider', borderRadius: '16px',
                    px: 1.25, py: 0.5,
                }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#43a047' }} />
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        w pracy {AmountOfCurrentCheckIn}
                    </Typography>
                </Box>
                <Box sx={{
                    display: 'flex', alignItems: 'center',
                    border: '1px solid', borderColor: 'divider', borderRadius: '16px',
                    px: 1.25, py: 0.5,
                }}>
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        dzisiaj {AmountOfWholeCheckIn}
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
                <Button variant="outlined" size="small" fullWidth onClick={() => setOpenAddModal(true)}>
                    + WPIS
                </Button>
                <Button variant="outlined" size="small" fullWidth onClick={() => setOpenAbsencesModal(true)}>
                    + URLOP
                </Button>
            </Box>

            <AttendanceAddNewRecord
                open={openAddModal}
                onClose={() => setOpenAddModal(false)}
                onRefresh={handleRefresh}
                currentTime={currentTime}
                idConfig={idConfig}
            />

            <AttendanceAddAbsences
                open={openAbsencesModal}
                onClose={() => setOpenAbsencesModal(false)}
                onRefresh={handleRefresh}
                currentTime={currentTime}
                idConfig={idConfig}
            />
        </Box>
    );
}

export default AttendanceMobileHeader;
